import { ballastItemLabel } from "../../../../utils/ballastItemLabel";
import { Button, Input, message, Modal, Switch, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../../widgets/AppToast";
import AppInput from "../../../../components/AppInput";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SelectInput from "../../../../components/SelectInput";
import useDocumentUpload from "../../../../hooks/useDocumentUpload";
import useUserData from "../../../../hooks/useUserData";

function AddBallastRecordBookModel({ visible, onClose, onSuccess, parent_id }) {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [code, set_code] = useState("");
  const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload();
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const [checked, setChecked] = useState(false);
  // const [parent_id, set_parent_id] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_BALLAST_RECORD_CODE_API();
  }, []);

  const LIST_BALLAST_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ballasting_codes_staff, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.operation_codes?.map((item) => {
            return {
              value: item?.value,
              label: item?.label,
            };
          });
          LIST_BALLAST_RECORD_ITEM_API(newRespones?.[0]?.value);
          setCodeList(res?.operation_codes);
          set_Previous_Log_Date(res?.last_record);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_BALLAST_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code", code_id);
      post(ApiURL.list_ballasting_items_staff, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.operation_items?.map((item) => {
            return {
              value: item?.id,
              label: ballastItemLabel(item?.item_number),
              sub_code_name: item?.description,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const SEND_NOTIFICATION_MASTER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("ballast", "1");
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new Ballast record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(
        ApiURL?.ballasting_requests_notification_st,
        FORM_DATA
      );
      if (response?.status === true) {
        SuccessToast(
          "Congratulations!",
          response?.message || "No message returned."
        );
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast(
        "Request Failed",
        "Could not complete the request. Please try again."
      );
    }
  };

  const ADD_BALLAST_RECORD_BOOK_APIS = async () => {
    const files = getFilesForUpload();
    set_loader(true);
    if (
      selectedItems?.some((item) => item.value === null || item.value === "")
    ) {
      ErrorToast("Selected Item Error", "All checked input should be filled");
      set_loader(false);
      return;
    }
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("code_category_id", code);
      FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
      FORM_DATA.append("date", date);
      FORM_DATA.append("ballasting_sign", signature);
      FORM_DATA.append("parent_id_for_H", parent_id);
      files?.forEach((files) => {
        FORM_DATA.append("files", files);
      });
      post(ApiURL.add_ballasting_details_staff, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast(
            "Congratulation!!",
            "Oil Record logbook Details Successfully Created!!"
          );
          navigate("/list-ballast-record");
          set_loader(false);
          onSuccess?.();
          onClose();

          if (designation && designation !== "Captain") {
            SEND_NOTIFICATION_MASTER(res?.id);
          }
          if (code !== "H") {
            navigate("/list-ballast-record");
          }
        } else {
          ErrorToast("Error message", res?.message);
          const error = res?.response?.data?.errors || {};
          console.log("error error error", res?.response?.data?.errors);
          set_errors(error);
          set_loader(false);
        }
      });
    } catch (error) {
      console.log("Errors *****", error);
    }
  };
  const hasFormChanged = () => {
    return (
      code &&
      date &&
      signature &&
      selectedItems.length > 0 &&
      selectedItems.every((item) => item.value && item.value.trim() !== "")
    );
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      if (exists) {
        return prevItems.filter((item) => item.id !== value);
      } else {
        return [...prevItems, { id: value, value: "" }];
      }
    });
  };

  const handleInputChange = (id, inputValue) => {
    setSelectedItems((prevItems) =>
      prevItems?.map((item) =>
        item.id === id ? { ...item, value: inputValue } : item
      )
    );
  };

  const getDocUrl = (file) => {
    if (file.url) return file.url; // existing file
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj); // newly uploaded
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (checked) {
      setOpen(true);
    }
  }, [checked, parent_id]);
  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loader}
            onClick={ADD_BALLAST_RECORD_BOOK_APIS}
          >
            Save
          </Button>,
        ]}
        width={1000}
      >
        <div className="white-container">
          <h3 style={{ color: "red", textAlign: "center" }}>
            Missed Operation Details{" "}
          </h3>
          <br />
          <h3>Ballast Record Information</h3>
          <br />
          <div className="row">
            <div className="col-6">
              <SelectInput
                label="Code"
                value={code}
                placeholder=" -- Selecte Code  -- "
                style={{ width: "100%" }}
                onChange={(value) => {
                  if (value !== "H") {
                    setChecked(false);
                  }
                  set_code(value);
                  setSelectedItems([]);
                  LIST_BALLAST_RECORD_ITEM_API(value);
                }}
                options={codeList}
                errors={errors?.code_category_id}
              />
            </div>
            <div className="col-6">
              <AppInput
                type="date"
                label="Date"
                placeholder="Date"
                value={date}
                onChange={(e) => set_date(e.target.value)}
                errors={errors.date}
                showInfo={code !== "H"}
                infoMessage="Original Operation Date"
                // min={previous_log_date}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          {code && (
            <div
              className="col-12"
              style={{
                lineHeight: "2",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
                marginBottom: "5px",
              }}
            >
              <strong className="form-label">Select Items:</strong>

              {codeItemList?.map((optionGroup, index) => (
                <div key={index} className="mb-3">
                  <div className="row align-items-center mb-2">
                    <div className="col-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some(
                            (item) => item.id === optionGroup.value
                          )}
                          onChange={() =>
                            handleCheckboxChange(optionGroup.value)
                          }
                          id={`group-checkbox-${index}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`group-checkbox-${index}`}
                        >
                          <strong>
                            {optionGroup.label} {optionGroup.sub_code_name}
                          </strong>
                        </label>
                      </div>
                    </div>

                    <div className="col-6">
                      {selectedItems.some(
                        (item) => item.id === optionGroup.value
                      ) && (
                        <Input
                          type="text"
                          required
                          className="form-control"
                          placeholder={optionGroup.label}
                          value={
                            selectedItems.find(
                              (item) => item.id === optionGroup.value
                            )?.value || ""
                          }
                          onChange={(e) =>
                            handleInputChange(optionGroup.value, e.target.value)
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {errors.sub_detail_values && (
            <ShowInputError errorMessage={errors.sub_detail_values} />
          )}

          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-6">
              <AppInput
                label="Name of operation incharge"
                placeholder="Name of operation incharge"
                value={signature}
                onChange={(e) => set_signature(e.target.value)}
                errors={errors.operation_details}
                showInfo={code !== "(H)"}
                infoMessage="Signatur of In-charge (or C/E if signed off)"
              />
            </div>
            <div className="col-6">
              <div
                className="input-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <label>Select File</label>
                <Upload
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  multiple
                  fileList={documentList}
                  onChange={handleDocumentChange}
                  onPreview={handlePreviews}
                  beforeUpload={() => false}
                  listType="picture"
                >
                  <Button
                    icon={<UploadOutlined />}
                    type="primary"
                    style={{
                      borderRadius: "50%",
                      padding: "10px",
                      width: "40px",
                      height: "40px",
                      marginLeft: "10px",
                    }}
                  ></Button>
                </Upload>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddBallastRecordBookModel;
